import type { EstoreInventoryPullDto } from "@/api/dtos";
import type { EstoreInventoryPull } from "@/api/report/_models/ReportUpload";

/** DTO → domain for one "Pull now": counts, and the first failure if any. */
export const toEstoreInventoryPullFromDto = (dto: EstoreInventoryPullDto): EstoreInventoryPull => {
  return {
    pulled: dto.pulled.length,
    remaining: dto.remaining,
    failed: dto.failed.length,
    firstError: dto.failed[0]?.error ?? null,
  };
};
